import React from "react";
import "@/App.css";
import BioLink from "./components/BioLink";

function App() {
  return (
    <div className="App">
      <BioLink />
    </div>
  );
}

export default App;